const AuthorStars = () => {
	return (
		<svg
			width="96"
			height="17"
			viewBox="0 0 96 17"
			style={{ position: 'relative', bottom: '2px' }}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.5754 6.21885L10.6567 5.46639L8.45208 0.763392C8.28741 0.412203 7.71208 0.412203 7.54741 0.763392L5.34342 5.46639L0.424765 6.21885C0.0207661 6.28094 -0.140567 6.77301 0.142766 7.06344L3.71609 10.7316L2.87143 15.9173C2.80409 16.3292 3.24342 16.6384 3.60676 16.4361L8.00008 14.0044L12.3934 16.4367C12.7534 16.637 13.1967 16.3339 13.1287 15.918L12.2841 10.7322L15.8574 7.06411C16.1407 6.77301 15.9787 6.28094 15.5754 6.21885Z"
				fill="#FFCB13"
			/>
			<path
				d="M35.5754 6.21885L30.6567 5.46639L28.4521 0.763392C28.2874 0.412203 27.7121 0.412203 27.5474 0.763392L25.3434 5.46639L20.4248 6.21885C20.0208 6.28094 19.8594 6.77301 20.1428 7.06344L23.7161 10.7316L22.8714 15.9173C22.8041 16.3292 23.2434 16.6384 23.6068 16.4361L28.0001 14.0044L32.3934 16.4367C32.7534 16.637 33.1967 16.3339 33.1287 15.918L32.2841 10.7322L35.8574 7.06411C36.1407 6.77301 35.9787 6.28094 35.5754 6.21885Z"
				fill="#FFCB13"
			/>
			<path
				d="M55.5754 6.21885L50.6567 5.46639L48.4521 0.763392C48.2874 0.412203 47.7121 0.412203 47.5474 0.763392L45.3434 5.46639L40.4248 6.21885C40.0208 6.28094 39.8594 6.77301 40.1428 7.06344L43.7161 10.7316L42.8714 15.9173C42.8041 16.3292 43.2434 16.6384 43.6068 16.4361L48.0001 14.0044L52.3934 16.4367C52.7534 16.637 53.1967 16.3339 53.1287 15.918L52.2841 10.7322L55.8574 7.06411C56.1407 6.77301 55.9787 6.28094 55.5754 6.21885Z"
				fill="#FFCB13"
			/>
			<path
				d="M75.5754 6.21885L70.6567 5.46639L68.4521 0.763392C68.2874 0.412203 67.7121 0.412203 67.5474 0.763392L65.3434 5.46639L60.4248 6.21885C60.0208 6.28094 59.8594 6.77301 60.1428 7.06344L63.7161 10.7316L62.8714 15.9173C62.8041 16.3292 63.2434 16.6384 63.6068 16.4361L68.0001 14.0044L72.3934 16.4367C72.7534 16.637 73.1967 16.3339 73.1287 15.918L72.2841 10.7322L75.8574 7.06411C76.1407 6.77301 75.9787 6.28094 75.5754 6.21885Z"
				fill="#FFCB13"
			/>
			<path
				d="M95.5754 6.21885L90.6567 5.46639L88.4521 0.763392C88.2874 0.412203 87.7121 0.412203 87.5474 0.763392L85.3434 5.46639L80.4248 6.21885C80.0208 6.28094 79.8594 6.77301 80.1428 7.06344L83.7161 10.7316L82.8714 15.9173C82.8041 16.3292 83.2434 16.6384 83.6068 16.4361L88.0001 14.0044L92.3934 16.4367C92.7534 16.637 93.1967 16.3339 93.1287 15.918L92.2841 10.7322L95.8574 7.06411C96.1407 6.77301 95.9787 6.28094 95.5754 6.21885Z"
				fill="#FFCB13"
			/>
		</svg>
	);
};

export default AuthorStars;
